export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BigText.vue?vue&type=template&id=53003919&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigText.vue?vue&type=template&id=53003919&scoped=true&
// module id = 279
// module chunks = 0